import request from '@/utils/request';
//列表
export function getSendReport(values) {
  return request('/mms/querySendReport', {
    method: 'POST',
    data: values,
  });
}
export function exportSendReport(values) {
  return request('/mms/exportSendReport', {
    method: 'POST',
    data: values,
  });
}
